import type { IProjectContext } from 'services/Store/Project/types'

export const getUrlParams = ({ urlParams }: IProjectContext) => urlParams

export const getCompanyId = ({ urlParams }: IProjectContext) => urlParams.companyId
export const getProjectId = ({ urlParams }: IProjectContext) => urlParams.projectId
export const getSectionId = ({ urlParams }: IProjectContext) => urlParams.sectionId
export const getBlockId = ({ urlParams }: IProjectContext) => urlParams.blockId

export const getNodeId = ({ state }: IProjectContext) =>
  state.editor.selectedNodes?.length === 1 ? state.editor.selectedNodes[0] : null
